"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJoystickNavigationThreshold = exports.setJoystickNavigationThreshold = void 0;
const entrypoint_1 = require("../../../foundation/entrypoint");
let joystickNavigationThreshold = 0.4;
const setJoystickNavigationThreshold = (threshold) => {
    if (threshold < 0 || threshold > 1) {
        joystickNavigationThreshold = threshold;
    }
    else {
        console.warn(entrypoint_1.consolePrefix, 'Joystick navigation threshold must be a number between 0 and 1');
    }
};
exports.setJoystickNavigationThreshold = setJoystickNavigationThreshold;
const getJoystickNavigationThreshold = () => {
    return joystickNavigationThreshold;
};
exports.getJoystickNavigationThreshold = getJoystickNavigationThreshold;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvcmUvbWFuYWdlcnMvaW5wdXQtbWFuYWdlci9qb3lzdGlja3MvY29tbW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCwrREFBK0Q7QUFFL0QsSUFBSSwyQkFBMkIsR0FBRyxHQUFHLENBQUM7QUFFL0IsTUFBTSw4QkFBOEIsR0FBRyxDQUFDLFNBQWlCLEVBQUUsRUFBRTtJQUNoRSxJQUFJLFNBQVMsR0FBRyxDQUFDLElBQUksU0FBUyxHQUFHLENBQUMsRUFBRSxDQUFDO1FBQ2pDLDJCQUEyQixHQUFHLFNBQVMsQ0FBQztJQUM1QyxDQUFDO1NBQU0sQ0FBQztRQUNKLE9BQU8sQ0FBQyxJQUFJLENBQUMsMEJBQWEsRUFBRSxnRUFBZ0UsQ0FBQyxDQUFDO0lBQ2xHLENBQUM7QUFDTCxDQUFDLENBQUM7QUFOVyxRQUFBLDhCQUE4QixrQ0FNekM7QUFFSyxNQUFNLDhCQUE4QixHQUFHLEdBQUcsRUFBRTtJQUMvQyxPQUFPLDJCQUEyQixDQUFDO0FBQ3ZDLENBQUMsQ0FBQztBQUZXLFFBQUEsOEJBQThCLGtDQUV6QyJ9